<template>
  <CHeader with-subheader>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <!-- <CHeaderBrand
      class="mx-lg-auto d-lg-none"
      src="~/img/brand/logo_skl.svg"
      width="97"
      height="46"
      alt="CoreUI Logo"
    /> -->
    <div class="d-none d-md-block d-lg-block d-xl-block">
      <CBreadcrumbRouter class="my-1 border-0" />
    </div>
    <CHeaderNav class="d-md-down-none mr-auto"> </CHeaderNav>
    <CHeaderNav class="ml-auto mr-2">
      <CHeaderNavItem class="mx-2">
        <b-dropdown
          id="dropdown-language"
          class="my-md-2 dropdown-language small-dropdown"
          right
          no-flip
        >
          <template v-slot:button-content>
            <div v-if="language == 'th'">
              <img src="@/assets/images/thailand.svg" class="lang-logo" />
            </div>
            <div v-else-if="language == 'en'">
              <img src="@/assets/images/eng.svg" class="lang-logo" />
            </div>
          </template>
          <template>
            <b-dropdown-item
              @click="changeLanguage('en')"
              :class="[{ active: language == 'en' }]"
              ><img src="@/assets/images/eng.svg" class="lang-logo" />
              ENG</b-dropdown-item
            >
            <b-dropdown-item
              v-if="this.$mode !== 'PROD_H_THAI_INDO'"
              @click="changeLanguage('th')"
              :class="[{ active: language == 'th' }]"
              ><img src="@/assets/images/thailand.svg" class="lang-logo" />
              TH</b-dropdown-item
            >
          </template>
        </b-dropdown>
      </CHeaderNavItem>
      <CHeaderNavItem class="mx-2" v-if="$store.getters.getShowDropdownBrand">
        <b-dropdown
          id="dropdown-1"
          class="my-md-2 btn-brand-selected small-dropdown"
          right
          no-flip
        >
          <template v-slot:button-content>
            {{ getBrandDetail().name }}
          </template>
          <template>
            <b-dropdown-item
              v-for="(brand, index) in getBrandList()"
              v-bind:key="index"
              @click="clickChangeBrand(brand)"
              :class="{ active: getBrandDetail().id === brand.id }"
            >
              {{ brand.name }}
            </b-dropdown-item>
          </template>
        </b-dropdown>
      </CHeaderNavItem>
      <CHeaderNavItem
        class="d-none d-md-block d-lg-block d-xl-block"
        v-if="getUserDetail()"
      >
        {{ getUserDetail().userName }}
      </CHeaderNavItem>

      <TheHeaderDropdownAccnt />
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import { mapGetters } from "vuex";

export default {
  name: "TheHeader",
  data() {
    return {
      language: this.$store.state.language,
      displayName: "",
      name: "",
      modalMessage: "Are you sure you want to log out ?",
    };
  },
  created: async function () {
    await this.$store.dispatch("flowBuilder/fetchTierMasterdataList");
  },
  computed: {
    ...mapGetters([
      "getBrandDetail",
      "getBrandList",
      "getCurrentBrandID",
      "getUserDetail",
    ]),
  },
  methods: {
    clickChangeBrand(brand) {
      let currentPath = this.$router.history.current.path;
      window.location.href = `${currentPath || "/"}?brandID=${brand.id}`;
    },
    changeLanguage(value) {
      this.language = value;
      this.$cookies.set("language", value);
      location.reload();
    },
  },
  components: {
    TheHeaderDropdownAccnt,
  },
};
</script>

<style scoped>
::v-deep .lang-dd button {
  background-color: transparent;
  border: none;
  padding: 0;
}

::v-deep .lang-dd button:focus,
::v-deep .lang-dd button:active,
::v-deep .lang-dd.show > .btn-secondary.dropdown-toggle,
::v-deep .lang-dd button:hover {
  background-color: transparent !important;
  border: none;
  padding: 0;
}

.lang-dd {
  border: 1px solid #dcdcdc;
  padding: 5px 10px;
}

::v-deep .lang-dd ul {
  width: 100px;
}

.modal-header {
  border-bottom: 0 !important;
  margin: 0px;
  padding: 0px;
  padding-bottom: 0.25rem;
}

.text-msg {
  font-size: 2rem;
  color: #4a4a4a;
}

.btn-modal {
  width: 100px;
  font-weight: bold;
}

.text-text {
  color: #4a4a4a;
  margin-bottom: 0;
  font-size: 1.2rem;
}

.img {
  width: 100px;
}
::v-deep .active > .dropdown-item {
  text-decoration: none;
  color: #455164;
  background-color: #e2dff3;
}
::v-deep .dropdown-menu.dropdown-menu-right {
  padding: 0 !important;
}
::v-deep #dropdown-language .dropdown-item {
  min-width: 55px;
  display: flex;
}
/* ::v-deep #dropdown-language button {
  min-width: 55px;
  display: flex;
} */
::v-deep #dropdown-language .dropdown-toggle::after {
  margin-top: auto !important;
  margin-bottom: auto !important;
}
::v-deep #dropdown-language .dropdown-menu .lang-logo {
  margin-right: 5px;
  width: 20px;
  height: 20px;
}
::v-deep #dropdown-language .dropdown-toggle .lang-logo {
  width: 20px;
  height: 20px;
}
</style>
